<div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h2 class="modal-title">{{ 'LABEL.TWO_FACTOR_AUTHENTICATION.TITLE' | translate }}</h2>
            <button type="button" class="btn-close" (click)="close(false)" data-bs-dismiss="modal"
                    aria-label="Close"></button>
        </div>
        <form name="confirmCodeForm" #tplForm="ngForm">
            <div class="modal-body">
                <div class="form-floating mb-2">
                    <input type="text" class="form-control" id="authenticatorCode" name="authenticatorCode" ngModel placeholder="Enter code">
                    <label for="authenticatorCode">{{ 'LABEL.AUTHORIZATION_CODE' | translate }}</label>
                    <validation-error class="invalid-feedback" for="authenticatorCode"/>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                        (click)="close(false)"
                        translate>BUTTON.CANCEL
                </button>
                <button class="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="submit"
                        (onValid)="submit($event)"
                        [disabled]="tplForm.disabled"
                        translate>BUTTON.CONTINUE
                </button>
            </div>
        </form>
    </div>
</div>
